module.exports = __webpack_public_path__ + "static/media/icon-beauty-full-disabled.6ae611e1.png";